import { Injectable } from '@angular/core'
import { HttpClient } from '@angular/common/http'
import { Observable } from 'rxjs/Observable'
import 'rxjs/add/operator/map'
import { Router } from '@angular/router'
import { ProfileModel } from '../models/profile.model'

import { environment } from '../../../environments/environment'
import { Location } from '@angular/common'
import { BehaviorSubject } from 'rxjs/BehaviorSubject'

@Injectable()
export class ProfileService {
  private readonly URL = environment.base_url + '/v1/user'
  onProfileChanged: BehaviorSubject<any> = new BehaviorSubject(ProfileModel)

  constructor(protected httpClient: HttpClient, private location: Location, private router: Router) {
    this.getStoredProfile()
  }

  public delete(profile: ProfileModel): Observable<ProfileModel> {
    return this.httpClient.delete<ProfileModel>(`${this.URL}/${profile.id}`)
  }

  public get(): Observable<ProfileModel> {
    return this.httpClient.get<ProfileModel>(`${this.URL}`)
  }

  public getStoredProfile() {
    if (localStorage.getItem('profile')) {
      const profile = new ProfileModel(JSON.parse(localStorage.getItem('profile')))
      this.onProfileChanged.next(profile)
      return profile
    }
  }

  public list(): Observable<Array<ProfileModel>> {
    return this.httpClient.get<Array<ProfileModel>>(this.URL)
  }

  public update(profile: ProfileModel): Observable<ProfileModel> {
    return this.httpClient.put<ProfileModel>(`${this.URL}/${profile.id}`, profile)
  }

  public storeProfile(profile: ProfileModel) {
    localStorage.setItem('profile', JSON.stringify(profile))
    this.onProfileChanged.next(profile)
  }
}



// WEBPACK FOOTER //
// ./src/app/main/services/profile.service.ts